import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface ITransactionApiClient {
    getCustomerTransactions(request: Models.Customer.TransactionSet.IGroupedTransactionRequest): ng.IPromise<Models.Customer.TransactionSet.IGroupedTransactionResponse>;
}

export class TransactionApiClient implements ITransactionApiClient {
    public static $inject = ['igs.apiClientService'];

    constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
    }

    public getCustomerTransactions = (request: Models.Customer.TransactionSet.IGroupedTransactionRequest): ng.IPromise<Models.Customer.TransactionSet.IGroupedTransactionResponse> => {
        return this.igsApiClientService.post("Transaction/GetCustomerTransactionsGroupedByInvoice", request);
    }
}